<template lang="html">
	<div class="lecturerHomepage">
		<HeadModule :openTarget="'teacher/home?id=' + this.$route.query.tuid" />

		<div class="banner">
			<img src="../assets/image/new.png">
		</div>
		<div class="lecturer_message">
			<div class="lecturer_head_img">
				<img :src="lecturer_details.avatar" alt="" class="lecturer_header">
				<p class="concern_lecturer_btn">
					＋关注
					<WxOpenTag :extinfo="'teacher/home?id=' + tuid"/>
				</p>
			</div>

			<div class="lecturer_head_data">
				<div class="lecturer_name">
					{{lecturer_details.username}}
				</div>
				<div class="lecturer_title">
					{{lecturer_details.title}}
				</div>
				<div class="lecturer_hot">
					<p class="attention">关注</p>
					<p class="attention_number">{{lecturer_details.following}}</p>
					<p class="fans">粉丝</p>
					<p class="fans_number">{{lecturer_details.follower}}</p>
				</div>
			</div>

			<div class="lecturer_datum" @click="myclick1()" v-bind:class="{'datumAll':show}">
				<p>查看详细资料</p>
				<div class="lecturer_datum_txt" v-html="lecturer_details.about"></div>
			</div>
		</div>

		<div class="open_APP_btn">
			打开APP查看更多
			<WxOpenTag :extinfo="'teacher/home?id=' + tuid"/>
		</div>

		<div class="tab_bar">
			<ul>
				<li id="tab1" @click="myclick(1, 'left')" v-bind:class="{'decorationLine':showLeft}">
					在教课程
				</li>
				<li id="tab2" @click="myclick(2, 'content')" v-bind:class="{'decorationLine':showContent}">
					在学课程
				</li>
				<li id="tab3" @click="myclick(3, 'right')" v-bind:class="{'decorationLine':showRight}">
					收藏课程
				</li>
			</ul>
		</div>
		<div class="tab_css" id="tab1_content" style="display: block">
			<div class="teach_course_mod">
				<div class="course_content" v-for="(m, index) in teach_video_data" :key="index">
					<div class="">
						<img class="course_img" :src="m.pic" alt="">
						<p class="course_title">
							{{m.title}}
						</p>
					</div>
					<WxOpenTag :extinfo="'openclass/detail?id=' + m.courseid"/>
				</div>
			</div>
			<div class="open_APP_btn">
				打开APP查看更多
				<WxOpenTag :extinfo="'teacher/home?id=' + tuid"/>
			</div>
		</div>
		<div class="tab_css" id="tab2_content">
			<div class="learn_course_mod">
				<div class="course_content" v-for="(m, index) in learn_video_data" :key="index">
					<div class="">
						<img class="course_img" :src="m.pic" alt="">
						<p class="course_title">
							{{m.title}}
						</p>
					</div>
					<WxOpenTag :extinfo="'openclass/detail?id=' + m.courseid"/>
				</div>
			</div>
			<div class="open_APP_btn">
				打开APP查看更多
				<WxOpenTag :extinfo="'teacher/home?id=' + tuid"/>
			</div>
		</div>
		<div class="tab_css" id="tab3_content">
			<div class="collect_course_mod">
				<div class="course_content" v-for="(m, index) in collect_video_data" :key="index">
					<div class="">
						<img class="course_img" :src="m.pic" alt="">
						<p class="course_title">
							{{m.title}}
						</p>
					</div>
					<WxOpenTag :extinfo="'openclass/detail?id=' + m.courseid"/>
				</div>
			</div>
			<div class="open_APP_btn">
				打开APP查看更多
				<WxOpenTag :extinfo="'teacher/home?id=' + tuid"/>
			</div>
		</div>
	</div>
</template>

<script>
	import HeadModule from '@/components/HeadModule'
	import WxOpenTag from '@/components/WxOpenTag'

	export default {
		components: {
			HeadModule: HeadModule,
			WxOpenTag: WxOpenTag,
		},
		data() {
			return {
				tuid: this.$route.query.tuid,
				lecturer_details: {},
				show: false,
				showLeft: true,
				showContent: false,
				showRight: false,
				teach_video_data: [],
				learn_video_data: [],
				collect_video_data: [],
			}
		},
		mounted() {
			this.details(this.$route.query.tuid);
			this.teach(this.$route.query.tuid);
			this.learn(this.$route.query.tuid);
			this.collect(this.$route.query.tuid);
		},
		methods: {
			// 讲师详情
			details(uid) {
				this.$http({
					url: '/edu/teacherDetail',
					method: 'get',
					params: {
						tuid: uid,
					},
				}).then((res) => {
					if (res.code >= 0) {
						this.lecturer_details = res.data;
					}
				})
			},
			// 在教课程
			teach(uid) {
				this.$http({
					url: '/edu/listTeaching',
					method: 'get',
					params: {
						start: 0,
						limit: 10,
						uid: uid,
					},
				}).then((res) => {
					if (res.code >= 0) {
						this.teach_video_data = res.data;
					}
				})
			},
			learn(uid) {
				this.$http({
					url: '/edu/listLearning',
					method: 'get',
					params: {
						start: 0,
						limit: 10,
						uid: uid,
					},
				}).then((res) => {
					if (res.code >= 0) {
						this.learn_video_data = res.data;
					}
				})
			},
			collect(uid) {
				this.$http({
					url: '/edu/listFavorite',
					method: 'get',
					params: {
						type: 0,
						start: 0,
						limit: 10,
						uid: uid,
					},
				}).then((res) => {
					if (res.code >= 0) {
						this.collect_video_data = res.data;
					}
				})
			},

			myclick1() {
				this.show = true;
			},
			myclick(v, type) {
				if (type === 'left') {
					this.showLeft = true;
					this.showContent = false;
					this.showRight = false;
				} else if (type === 'content') {
					this.showLeft = false;
					this.showContent = true;
					this.showRight = false;
				} else if (type === 'right') {
					this.showLeft = false;
					this.showContent = false;
					this.showRight = true;
				}
				var divs = document.getElementsByClassName("tab_css");
				for (var y = 0; y < divs.length; y++) {
					var divv = divs[y];
					if (divv == document.getElementById("tab" + v + "_content")) {
						divv.style.display = "block";
					} else {
						divv.style.display = "none";
					}
				}
			},
		},
	}
</script>

<style lang="css" scoped>
	/* 全局 */
	.lecturerHomepage {
		background-color: #F7F8F8;
	}

	.banner {
		width: 100%;
		height: 100px;
	}

	.banner img {
		width: 100%;
		height: 100px;
		object-fit: cover;
	}

	.lecturer_message {
		background-color: #fff;
		padding: 0 15px;
	}

	/* 头像 */
	.lecturer_head_img {
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.lecturer_header {
		margin-top: -35px;
		width: 80px;
		height: 80px;
		border: 3px solid #fff;
		border-radius: 50%;
		object-fit: cover;
	}

	/* 关注按钮 */
	.concern_lecturer_btn {
		position: relative;
		margin-top: -10px;
		width: 62px;
		height: 24px;
		line-height: 24px;
		border-radius: 12px;
		text-align: center;
		background-color: red;
		color: #fff;
		font-size: 14px;
	}

	.lecturer_head_data {
		box-sizing: border-box;
		margin-top: 12px;
	}

	/* 讲师名称 */
	.lecturer_name {
		font-size: 21px;
		color: #1D2023;
	}

	.lecturer_title {
		font-size: 14px;
		color: #606972;
	}

	/* 热度 */
	.lecturer_hot {
		display: flex;
		align-items: center;
		margin-top: 7px;
	}

	.attention,
	.fans {
		font-size: 10px;
		color: #606972;
		margin-right: 3px;
	}

	.attention_number,
	.fans_number {
		font-size: 14px;
		color: #1D2023;
		margin-right: 16px;
	}

	/* 详细资料 */
	.lecturer_datum {
		margin-top: 18px;
		box-sizing: border-box;
		height: 120px;
		overflow: hidden;
	}

	.datumAll {
		height: 100%;
		overflow: inherit;
	}

	.lecturer_datum_txt {
		line-height: 22px;
		margin-top: 10px;
		font-size: 14px;
		color: #3F454B
	}

	/* tab切换 */
	.tab_bar {
		box-sizing: border-box;
		background-color: #fff;
		width: 100%;
		height: 44px;
		padding: 0 15px;
	}

	.tab_bar ul {
		padding: 0px;
		margin: 0px;
		height: 44px;
		text-align: center;
		border-bottom: 0.5px solid rgba(0, 0, 0, 0.07);
	}

	.tab_bar li {
		font-size: 18px;
		list-style-type: none;
		float: left;
		width: 33.33%;
		height: 44px;
		line-height: 44px
	}

	/* 装饰线 */
	.decorationLine {
		color: red;
		position: relative;
	}

	.decorationLine:after {
		content: '';
		position: absolute;
		left: 50%;
		right: 0;
		text-align: center;
		bottom: 0;
		height: 2px;
		width: 30px;
		margin-left: -15px;
		background-color: #F00021;
	}

	.tab_css {
		display: none;
		padding-bottom: 1px;
	}

	/* 在线教课 */
	.teach_course_mod, .learn_course_mod, .collect_course_mod {
		margin-top: 1px;
		padding: 0 15px;
		padding-bottom: 15px;
		background-color: #fff;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		box-sizing: border-box;
	}

	.course_content {
		position: relative;
		width: 48.5%;
		height: 146px;
		margin-top: 15px;
	}

	.course_img {
		width: 100%;
		height: 103px;
		border-radius: 5px;
		object-fit: cover;
	}

	.course_title {
		font-size: 14px;
		color: #1D2023;
		overflow: hidden;
		-webkit-line-clamp: 2;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
	}

	/* 下载按钮 */
	.open_APP_btn {
		position: relative;
		margin: 10px 15px;
		border-radius: 3px;
		height: 35px;
		line-height: 35px;
		background-color: #E50120;
		text-align: center;
		color: #FCFCFC;
		font-size: 16px;
	}
</style>
